export default __webpack_public_path__ + "static/media/notification_red.88b9b08c.svg";